import { render, staticRenderFns } from "./module-bar.vue?vue&type=template&id=33d2037b&scoped=true"
import script from "./module-bar.vue?vue&type=script&lang=js"
export * from "./module-bar.vue?vue&type=script&lang=js"
import style0 from "./module-bar.vue?vue&type=style&index=0&id=33d2037b&prod&lang=scss"
import style1 from "./module-bar.vue?vue&type=style&index=1&id=33d2037b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2037b",
  null
  
)

export default component.exports